import React from 'react';
import { useTranslation } from 'react-i18next';
import { DashboardEmbed } from '../../components/DashboardEmbed';
import { getDashboardUrlByRole, getDashboardTitle, getDashboardDescription } from '../../config/dashboards';

export const LogistiqueDashboard = ({ user }: { user: any }) => {
  const { t } = useTranslation();
  const role = user?.role;
  return (
    <div className="p-4 md:p-6">
      <div className="mb-5">
        <h1 className="text-2xl font-bold text-white mb-1">{t('dashboard.logistics_fleet')}</h1>
        <p className="text-gray-400 text-sm">Gestion de la flotte et maintenance préventive</p>
      </div>
      <div className="space-y-10">
        <DashboardEmbed title={getDashboardTitle('logistics_fleet')} embedUrl={getDashboardUrlByRole(role,'logistics_fleet')} description={getDashboardDescription('logistics_fleet')} userRole={role}/>
        <DashboardEmbed title={getDashboardTitle('logistics_failures')} embedUrl={getDashboardUrlByRole(role,'logistics_failures')} description={getDashboardDescription('logistics_failures')} userRole={role}/>
      </div>
    </div>
  );
};
